import { render, staticRenderFns } from "./ListaHorariosQueORoboSeparou.vue?vue&type=template&id=595a5370&scoped=true"
import script from "./ListaHorariosQueORoboSeparou.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaHorariosQueORoboSeparou.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595a5370",
  null
  
)

export default component.exports